import React from 'react' 
import { Link } from 'react-router-dom'

export default function PageNotFound() {
  return (
    <> 
        <div className="error-404">
                <div className="inner">

              <div className="t-inner">
                  <img src="/images/img-404.png" />
                  <div>
                      <h1>THE PAGE YOU REQUESTED WASN’T FOUND</h1>
                      <p>The page you were trying to reach does not exist. You may have mistyped the url, or the page may have been moved or deleted.</p>
                      <Link className="btn" to="/">Go Home</Link>
                  </div>
              </div>
          </div>
        </div>
    </>
  )
}
